module.exports = __webpack_public_path__ + "static/media/livercancer.8ee2ddfb.svg";